const LOCAL_HOST = "//www.testcn.com";
const PRO_HOST = "//www.thecn.com";
const DEV_HOST = "//dev.thecn.com";
const CN_HOSTS = window.location.host.split(".");

function getBrand() {
  return (2 < CN_HOSTS.length && CN_HOSTS[CN_HOSTS.length - 3]) || "brand";
}
function getDomain() {
  let domain = PRO_HOST;
  if (
    "development" === process.env.NODE_ENV ||
    "testcn" === CN_HOSTS[CN_HOSTS.length - 2]
  ) {
    domain = LOCAL_HOST;
  } else if ("cnschool" === getBrand()) {
    domain = DEV_HOST;
  }
  return domain;
}

const CN_BRAND = getBrand();
const CN_HOST = getDomain();
const CN_API_ROOT = `${CN_HOST}/api`;
const STATIC = {
  siteRedirectUrl: `${CN_HOST}/site/token/`,
  apiLogin: `${CN_HOST}/api/auth`,
  action: "login"
};
export { CN_HOST, CN_BRAND, CN_API_ROOT, STATIC };
